import React from "react";
const Preset4 = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("rect", { x: "32", y: "24", width: "48", height: "35", rx: "2", fill: "url(#paint0_linear_6001_4812)" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M40.6453 45.5953L32 52.0204V57C32 58.1046 32.8954 59 34 59H78C79.1046 59 80 58.1046 80 57V48.1429L70.833 41.33C69.7706 40.5404 68.3163 40.5404 67.254 41.33L52.8696 52.0204L44.2243 45.5953C43.1619 44.8057 41.7076 44.8057 40.6453 45.5953Z",
        fill: "url(#paint1_linear_6001_4812)"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { x: "32", y: "80", width: "48", height: "8", rx: "2", fill: "#116DFF" }),
    /* @__PURE__ */ React.createElement("rect", { x: "32", y: "65", width: "48", height: "3", rx: "1.5", fill: "#868AA5" }),
    /* @__PURE__ */ React.createElement("rect", { x: "32", y: "71", width: "3", height: "3", rx: "1.5", fill: "#000624", fillOpacity: "0.3" }),
    /* @__PURE__ */ React.createElement("rect", { x: "36", y: "71", width: "9", height: "3", rx: "1.5", fill: "#000624", fillOpacity: "0.3" }),
    /* @__PURE__ */ React.createElement("circle", { cx: "47", cy: "36", r: "4", fill: "white" }),
    /* @__PURE__ */ React.createElement("rect", { x: "28.5", y: "20.5", width: "55", height: "71", rx: "3.5", stroke: "#DFE5EB" }),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_6001_4812",
        x1: "56",
        y1: "24",
        x2: "56",
        y2: "59",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ), /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint1_linear_6001_4812",
        x1: "56",
        y1: "40",
        x2: "56",
        y2: "59",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ))
  );
};
export {
  Preset4
};
//# sourceMappingURL=Preset4.js.map
